import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import cloneDeep from "lodash/cloneDeep";

import WizardGroupsAside from "./WizardGroupsAside";
import {setWizardPendingList} from "../wizardActions";
import WizardGroupsTopButtons from "./WizardGroupsTopButtons";
import WizardGroupsFlow from "./WizardGroupsFlow";

const WizardGroups = (props) => {

  const {wizardId, wizardList, setWizardPendingList} = props;
  const wizardActiveItem = wizardList.find(wizardItem => wizardItem.id === wizardId);

  if (!wizardActiveItem) {
    return (
      <div className="wizard-groups wizard-groups--center">
        <FormattedMessage id="wizard.groups.noAvailableWizardFound"/>
      </div>
    )
  }

  useEffect(() => {
    setWizardPendingList(cloneDeep(wizardList));
    return () => {
      setWizardPendingList([]);
    }
  }, []);

  return (
    <div className="wizard-groups">
      <WizardGroupsAside wizardActiveItem={wizardActiveItem}/>
      <div className="wizard-groups__content">
        <WizardGroupsTopButtons wizardActiveItem={wizardActiveItem}/>
        <WizardGroupsFlow wizardActiveItem={wizardActiveItem}/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardList, wizardDraggingGroupIndex} = store.wizardState;
  return {
    wizardList,
    wizardDraggingGroupIndex,
  };
};

const mapDispatchToProps = {
  setWizardPendingList,
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardGroups)
